import { Trans } from "@lingui/macro";
import { WfButton } from "@WahooFitness/redesignr";
import WfActionGroup from "@WahooFitness/redesignr/dist/Actions/WfActionGroup/WfActionGroup.js";

interface Props {
  onSave: () => void;
  onDiscard: () => void;
}

function SaveDiscardButtons({ onSave, onDiscard }: Props) {
  return (
    <WfActionGroup orientation="horizontal" sticky fullWidth maxContentWidth="sm">
      <WfButton
        hierarchy="tertiary"
        intent="destructive"
        size="large"
        fullWidth
        onClick={onDiscard}
      >
        <Trans>Discard</Trans>
      </WfButton>
      <WfButton hierarchy="primary" size="large" fullWidth onClick={onSave}>
        <Trans>Save results</Trans>
      </WfButton>
    </WfActionGroup>
  );
}

export default SaveDiscardButtons;
